import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowLeft } from "lucide-react";

/** The arrow at the start of a create/edit page's header that returns to the record's list. */
export function BackToList({ to }: { to: string }) {
  const { t } = useTranslation("common");
  const label = t("backToList", { defaultValue: "Back to list" });
  return (
    <Link
      to={to}
      aria-label={label}
      title={label}
      className="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-lg border border-[rgb(var(--border))] bg-[rgb(var(--card))] text-[rgb(var(--text-primary))] transition hover:bg-[rgb(var(--card-muted))] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[rgb(var(--text-accent))]"
    >
      <ArrowLeft size={18} aria-hidden />
    </Link>
  );
}
